import { IconProps } from '@/types/icon';

export function IconeCarteira({ size, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="carteira"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M2.62598 2.09961H10.792C11.2404 2.09961 11.6094 2.46863 11.6094 2.91699V4.44629L11.7803 4.54785C12.0289 4.69533 12.1924 4.95386 12.1924 5.25V8.75C12.1924 9.04614 12.0289 9.30467 11.7803 9.45215L11.6094 9.55371V11.083C11.6094 11.5314 11.2404 11.9004 10.792 11.9004H2.62598C2.17292 11.9004 1.80859 11.5325 1.80859 11.083V2.91699C1.80859 2.46748 2.17292 2.09961 2.62598 2.09961ZM2.27539 11.4336H11.1426V9.56641H7.29199C6.84377 9.56623 6.47559 9.19826 6.47559 8.75V5.25C6.47559 4.80174 6.84377 4.43377 7.29199 4.43359H11.1426V2.56641H2.27539V11.4336ZM6.94238 9.09961H11.7256V4.90039H6.94238V9.09961ZM9.04199 6.47461C9.33194 6.47461 9.56738 6.71005 9.56738 7C9.56738 7.28995 9.33194 7.52539 9.04199 7.52539C8.75219 7.52522 8.51758 7.28984 8.51758 7C8.51758 6.71016 8.75219 6.47478 9.04199 6.47461Z"
        stroke="currentColor"
        strokeWidth="0.7"
      />
    </svg>
  );
}
